import { useTheme } from 'styled-components';
import type { SellerRatingProps } from './SellerRating.typed';
import * as Styled from './SellerRating.styled';
import { MiniRatingSummary } from '../../../../Ratings/MiniRatingSummary/MiniRatingSummary';
import { StarIc } from '@dsch/dd-icons';

const SellerRating = (props: SellerRatingProps) => {
  const { rating, sellerTypeText, onClickRatings, onClickReviews } = props;
  const { average, reviewCount } = rating || {};
  const theme = useTheme();

  return (
    <>
      <Styled.SellerType data-testid={'seller-type'}>
        <Styled.SellerTypeLink
          color="GREY_DARK"
          colorVariant="GREY_DARK"
          fontSize="M16"
          ofType="SECONDARY"
          aria-label="view seller reviews"
          onClick={onClickReviews}
        >
          {sellerTypeText}
        </Styled.SellerTypeLink>
      </Styled.SellerType>

      <MiniRatingSummary
        onClickRatings={onClickRatings}
        onClickReviews={onClickReviews}
        average={average}
        reviewCount={reviewCount}
        leadingIcon={
          <StarIc
            height={16}
            width={16}
            color={average ? theme.colors.ORANGE : theme.colors.GREY_DARK}
          />
        }
      />
    </>
  );
};

export { SellerRating };
